import {ImageField, ImageInput, TextInput} from "react-admin";
import {EditPopup} from "../../../components/Admin/Pages/EditPopup/EditPopup";
import {seasonService} from "../../../services/seasonService";
import {ReferenceInput} from "../../../components/Admin/Form/components/inputs/ReferenceInput/ReferenceInput";
import dayjs from "dayjs";
import {collectionService} from "../../../services/collectionService";
import Box from "@mui/material/Box";

export const CollectionEdit = () => {
    return (
        <EditPopup updateQuery={collectionService.update} getRecordQuery={collectionService.getById}>
            <TextInput source="name" fullWidth size="medium"/>
            <ReferenceInput
                source="season"
                choices={seasonService.getList}
                optionText={(value) => dayjs(value.startDate).format("DD.MM.YYYY")}
                fullWidth
            />
            <Box sx={{display: "flex", flexDirection: "row", gap: "10px"}}>
                <Box sx={{display: "flex", flexDirection: "column", gap: "10px"}}>
                    <ImageInput source="commonPackTexture.albedoTransparency" fullWidth accept={{'image/*': ['.png', '.jpg']}}>
                        <ImageField source="src" title="title"/>
                    </ImageInput>
                    <ImageInput source="commonPackTexture.metallicSmoothness" fullWidth accept={{'image/*': ['.png', '.jpg']}}>
                        <ImageField source="src" title="title"/>
                    </ImageInput>
                    <ImageInput source="commonPackTexture.normal" fullWidth accept={{'image/*': ['.png', '.jpg']}}>
                        <ImageField source="src" title="title"/>
                    </ImageInput>
                    <ImageInput source="commonCapBackTexture.albedoTransparency" fullWidth accept={{'image/*': ['.png', '.jpg']}}>
                        <ImageField source="src" title="title"/>
                    </ImageInput>
                </Box>
                <Box sx={{display: "flex", flexDirection: "column", gap: "10px"}}>
                    <ImageInput source="rarePackTexture.albedoTransparency" fullWidth accept={{'image/*': ['.png', '.jpg']}}>
                        <ImageField source="src" title="title"/>
                    </ImageInput>
                    <ImageInput source="rarePackTexture.metallicSmoothness" fullWidth accept={{'image/*': ['.png', '.jpg']}}>
                        <ImageField source="src" title="title"/>
                    </ImageInput>
                    <ImageInput source="rarePackTexture.normal" fullWidth accept={{'image/*': ['.png', '.jpg']}}>
                        <ImageField source="src" title="title"/>
                    </ImageInput>
                    <ImageInput source="rareCapBackTexture.albedoTransparency" fullWidth accept={{'image/*': ['.png', '.jpg']}}>
                        <ImageField source="src" title="title"/>
                    </ImageInput>
                </Box>
                <Box sx={{display: "flex", flexDirection: "column", gap: "10px"}}>
                    <ImageInput source="legendaryPackTexture.albedoTransparency" fullWidth accept={{'image/*': ['.png', '.jpg']}}>
                        <ImageField source="src" title="title"/>
                    </ImageInput>
                    <ImageInput source="legendaryPackTexture.metallicSmoothness" fullWidth accept={{'image/*': ['.png', '.jpg']}}>
                        <ImageField source="src" title="title"/>
                    </ImageInput>
                    <ImageInput source="legendaryPackTexture.normal" fullWidth accept={{'image/*': ['.png', '.jpg']}}>
                        <ImageField source="src" title="title"/>
                    </ImageInput>
                    <ImageInput source="legendaryCapBackTexture.albedoTransparency" fullWidth accept={{'image/*': ['.png', '.jpg']}}>
                        <ImageField source="src" title="title"/>
                    </ImageInput>
                </Box>
            </Box>
        </EditPopup>
    );
};